class UniversityReservation {
  constructor(rootSelector) {
    this.root =
      typeof rootSelector === 'string'
        ? document.querySelector(rootSelector)
        : rootSelector;

    if (!this.root) {
      return;
    }

    this.limit = Math.max(
      1,
      parseInt(this.root.dataset.selectionLimit || '2', 10) || 2
    );
    this.contactUrl = this.root.dataset.contactUrl || '';
    this.firstParam = this.root.dataset.firstParam || 'session_first';
    this.secondParam = this.root.dataset.secondParam || 'session_second';
    this.applyBtn = this.root.querySelector('.js-university-reservation-apply');
    this.inputs = Array.from(
      this.root.querySelectorAll('.p-university__reservation-input')
    );
    /** チェックした順（第1希望 → 第2希望）。DOM 順ではない。 */
    this.selectionOrder = [];

    this.inputs.forEach((input) => {
      if (input.checked) {
        this.selectionOrder.push(input);
      }

      input.addEventListener('change', () => this.onChange(input));
    });

    this.root.addEventListener('click', (event) => {
      this.handleItemClick(event);
    });

    if (this.applyBtn) {
      this.applyBtn.addEventListener('click', (event) => {
        if (
          this.applyBtn.classList.contains('is-disabled') ||
          this.applyBtn.getAttribute('aria-disabled') === 'true'
        ) {
          event.preventDefault();
        }
      });
    }

    this.sync();
  }

  handleItemClick(event) {
    const item = event.target.closest('.p-university__reservation-item');

    if (
      !(item instanceof HTMLElement) ||
      !this.root.contains(item) ||
      item.classList.contains('is-full') ||
      item.classList.contains('is-limit')
    ) {
      return;
    }

    const input = item.querySelector('.p-university__reservation-input');

    if (!(input instanceof HTMLInputElement) || input.disabled) {
      return;
    }

    // input 自体のクリックはブラウザ標準の change に任せる
    if (event.target === input) {
      return;
    }

    // label は Android で反応しないことがあるため preventDefault して手動トグル
    if (event.target.closest('.p-university__reservation-label')) {
      event.preventDefault();
    }

    input.checked = !input.checked;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  getCheckedInOrder() {
    return this.selectionOrder.filter((input) => input.checked);
  }

  onChange(input) {
    if (input.checked) {
      if (this.selectionOrder.length >= this.limit) {
        input.checked = false;
        return;
      }

      if (!this.selectionOrder.includes(input)) {
        this.selectionOrder.push(input);
      }
    } else {
      this.selectionOrder = this.selectionOrder.filter((item) => item !== input);
    }

    this.sync();
  }

  sync() {
    this.selectionOrder = this.getCheckedInOrder();
    const checked = this.selectionOrder;
    const atLimit = checked.length >= this.limit;

    this.inputs.forEach((input) => {
      const item = input.closest('.p-university__reservation-item');
      const status = item
        ? item.querySelector('.p-university__reservation-status')
        : null;
      const order = checked.indexOf(input);
      const isSelected = order >= 0;

      if (item) {
        item.classList.toggle('is-limit', !isSelected && atLimit);
      }

      if (isSelected) {
        input.disabled = false;
        if (status) {
          status.hidden = false;
          status.textContent = order === 0 ? '第1希望' : '第2希望';
        }
        return;
      }

      if (atLimit) {
        input.disabled = true;
        if (status) {
          status.hidden = false;
          status.innerHTML = '上限数に<br>達しています';
        }
        return;
      }

      input.disabled = false;
      if (status) {
        status.hidden = true;
        status.textContent = '';
      }
    });

    if (!this.applyBtn) {
      return;
    }

    if (checked.length === 0 || !this.contactUrl) {
      this.applyBtn.href = this.contactUrl || '#';
      this.applyBtn.classList.add('is-disabled');
      this.applyBtn.setAttribute('aria-disabled', 'true');
      this.applyBtn.setAttribute('tabindex', '-1');
      return;
    }

    const url = new URL(this.contactUrl, window.location.origin);
    url.searchParams.set(this.firstParam, checked[0].value);

    if (checked[1]) {
      url.searchParams.set(this.secondParam, checked[1].value);
    } else {
      url.searchParams.delete(this.secondParam);
    }

    this.applyBtn.href = url.toString();
    this.applyBtn.classList.remove('is-disabled');
    this.applyBtn.setAttribute('aria-disabled', 'false');
    this.applyBtn.removeAttribute('tabindex');
  }
}
